import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = 'DPDP Guide - DPDP Act & Rules',
  description = 'Comprehensive guide to India\'s Digital Personal Data Protection Act (DPDP) 2023 and DPDP Rules. Explore sections, cross-references, and compliance guidance.',
  keywords = 'DPDP Act, Digital Personal Data Protection, India data privacy, DPDP Rules, data protection compliance, data principal rights',
  canonicalUrl,
  ogImage,
  structuredData,
}) => {
  const siteName = 'DPDP Guide';

  return (
    <Helmet>
      {/* Basic Meta */}
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="robots" content="index, follow" />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}

      {/* Canonical URL */}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      {/* Structured Data (JSON-LD) */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
